<template>
  <div class="food-manage">
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="支付渠道名称" prop="channel_name" align="center" />
        <el-table-column label="应用场景" prop="channel_scene" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnEditChannel(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetAppChannelList" />
    </div> -->

    <el-dialog title="参数" :visible.sync="bCreateReply" width="70%">
      <el-form :model="postForm" class="fn-clear">
        <div v-if="currentCannel.channel_name == '支付宝当面付'">
          <el-form-item label="APP ID">
            <el-input v-model="postForm.appid" />
          </el-form-item>
          <el-form-item label="支付宝公钥">
            <el-input v-model="postForm.public_key" type="textarea" />
          </el-form-item>
          <el-form-item label="应用私钥">
            <el-input v-model="postForm.private_key" type="textarea" />
          </el-form-item>
        </div>
        <div v-if="currentCannel.channel_name != '支付宝当面付'">
          <el-form-item label="关联的公众号 APP ID">
            <el-input v-model="postForm.appid" />
          </el-form-item>
          <el-form-item label="微信支付商户号">
            <el-input v-model="postForm.wechat_merchant_no" />
          </el-form-item>
          <el-form-item label="商户APlv2秘钥">
            <el-input v-model="postForm.wechat_pay_key" />
          </el-form-item>
          <el-form-item label="商户API证书 apiclient_cert.pem">
            <el-input v-model="postForm.public_key" type="textarea" />
          </el-form-item>
          <el-form-item label="商户API证书私钥 apiclient_key.pem">
            <el-input v-model="postForm.private_key" type="textarea" />
          </el-form-item>
        </div>

      </el-form>
      <el-button type="primary" @click="fnSubmitCreate()">提交</el-button>
    </el-dialog>
  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'ShopClassList',
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      bCreateReply: false,
      listQuery: {
        appId: ''
      },
      currentCannel: '',
      postForm: {
        appid: '',
        id: '',
        public_key: '',
        private_key: '',
        app_secret_key: '',
        wechat_merchant_no: '',
        wechat_pay_key: ''
      }
    }
  },
  created() {
    this.listQuery.appId = this.$route.query.appId
    this.fnGetAppChannelList()
  },
  methods: {
    fnGetAppChannelList: function() {
      this.bCreateReply = false
      this.$http.getChannelList(this.listQuery).then(res => {
        this.lists = res.data
      })
    },
    fnPopCreate() {
      this.postForm.class_id = ''
      this.postForm.name = ''
      this.bCreateReply = true
    },
    fnSubmitCreate: function() {
      this.$http.improveChannelInfo(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('设置成功')
          this.fnGetAppChannelList()
        }
      })
    },
    fnEditChannel(channel) {
      this.currentCannel = channel
      const channelId = this.currentCannel.id
      this.$http.getChannelInfo({ channelId }).then(res => {
        this.postForm = Object.assign(this.postForm, res.data)
        console.log(this.postForm)
        this.bCreateReply = true
      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
